const ENDPOINT = 'servers';

export default axios => ({
  /**
   * Get SMTP_INPUT list, list of all message groups
   * @param params - params to path on backend
   * @return {*}
   */
  getList(params) {
    return axios.get(`/${ENDPOINT}/`, {
      redirect: 'follow',
      params
    });
  },

  /**
   * Get schema
   * @return {*}
   */
  getSchema() {
    return axios.get('/schemas/servers.json');
  },

  // /**
  //  * Get messages group data.
  //  * @param id
  //  * @return {*}
  //  */
  // getGroup(id) {
  //   return axios.get(`/${ENDPOINT}/message/${id}`);
  // },
  //
  // /**
  //  * Delete group with all messages
  //  * @param id - group id
  //  * @return {*}
  //  */
  // deleteGroup(id) {
  //   return axios.delete(`/${ENDPOINT}/list/${id}`);
  // },
  //
  // /**
  //  * Delete messages from group
  //  * @param ids - messages ids
  //  * @return {*}
  //  */
  // deleteGroupMessages(ids) {
  //   if (Array.isArray(ids)) {
  //     return axios.delete(`/${ENDPOINT}/message/`, {
  //       redirect: 'follow',
  //       data: JSON.stringify(ids)
  //     });
  //   } else {
  //     throw new Error(`Can't delete group messages ids: ${ids} must be an Array`);
  //   }
  // },
});



// WEBPACK FOOTER //
// ./src/services/servers.service.js